import React from 'react';

// Styles
import './PrintPageSectionTitle.scss';

type Props = {
  superScript?: string;
  title: string;
};
const PrintPageSectionTitle = ({ superScript, title }: Props) => {
  const baseClassName = 'PrintPageSectionTitle';

  return (
    <div className={baseClassName}>
      {superScript && <span className={`${baseClassName}__superscript`}>{superScript}</span>}
      <h5 className={`${baseClassName}__title`}>{title}</h5>
      <div className={`${baseClassName}__divider`} />
    </div>
  );
};

export default PrintPageSectionTitle;
